const spacing = {
  space20: '20px'
};

export default spacing;
